import { Button, Card } from "tunggal";
import React from 'react';
export default {
  Button,
  Card,
  React
};